module.exports = __webpack_public_path__ + "static/media/motive.eaa39cef.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/motive.png
// module id = 123
// module chunks = 0